import * as firebase from 'firebase';
import Button from '@material-ui/core/Button';

export const Logout = () => (
  <Button onClick={() => firebase.auth().signOut()} variant="contained" id="logout">
    Log out
  </Button>
);